// Целият период на `GET /reports/analytics/ordered-items`, събран на страници.
//
// Ендпойнтът е страниран с таван `page_size = 200`, а два потребителя искат
// ВСИЧКИ редове, не текущата страница: Excel експортът на „По артикули" и
// групирането по категория в „По категории". Затова листенето живее тук, а не
// в двете справки поотделно.
//
// Агрегатите (`unique_items_count`, `total_quantity`, `grand_total`) BE-то
// смята върху целия филтриран набор ПРЕДИ страницирането — затова се четат от
// първия отговор и не се пресмятат наум от събраните редове.

import {
  getOrderedItems,
  type OrderedItem,
  type OrderedItemsFilters,
} from "../../../../api/reports";
import { parseDecimal } from "../../../../components/dataTable";

/** Таванът на `page_size` в BE-то (`le=200`) — по-голям връща 422. */
export const ORDERED_ITEMS_MAX_PAGE_SIZE = 200;

/** Предпазител срещу безкрайно листене при неочакван `total`. */
const MAX_PAGES = 50;

export type AllOrderedItems = {
  items: OrderedItem[];
  /** Брои по (продаваем, вид), не по `item_id` — виж docs/reports.md. */
  uniqueItemsCount: number;
  totalQuantity: number;
  grandTotal: number;
};

export const fetchAllOrderedItems = async (
  filters: OrderedItemsFilters,
): Promise<AllOrderedItems> => {
  const items: OrderedItem[] = [];
  let uniqueItemsCount = 0;
  let totalQuantity = 0;
  let grandTotal = 0;

  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const response = await getOrderedItems({
      ...filters,
      page,
      page_size: ORDERED_ITEMS_MAX_PAGE_SIZE,
    });
    if (page === 1) {
      uniqueItemsCount = response.unique_items_count;
      totalQuantity = parseDecimal(response.total_quantity);
      grandTotal = parseDecimal(response.grand_total);
    }
    items.push(...response.items);
    if (
      response.items.length < ORDERED_ITEMS_MAX_PAGE_SIZE ||
      items.length >= response.total
    ) {
      break;
    }
  }

  return { items, uniqueItemsCount, totalQuantity, grandTotal };
};
